<template>
  <div class="first-prediction" v-if="section">
    <div class="first-prediction__card">
<!--      <div class="first-prediction__header">-->
<!--        <span class="first-prediction__name">{{ gameLabel }} {{ section.sectionName }}</span>-->
<!--      </div>-->
      <div  class="card_header" >
        <b><font face="微软夜黑" style="font-size: 18pt" color="#FFFFFF">{{gameLabel}} {{ section.sectionName }}</font></b>
      </div>
      <div
        v-for="(item, idx) in visibleItems"
        :key="idx"
        class="first-prediction__row"
        :class="{ 'first-prediction__row--divider': idx > 0 }"
      >
        <span class="first-prediction__period">
          <span class="card_header">第{{ periodShort(item.period) }}期 {{ section.sectionName }}&nbsp; </span>
          <span>{{ item.resultText }}</span>
        </span>
        <div class="first-prediction__content">
          <template v-for="(line, li) in parsedLines(item)">
            <div v-if="line.divider" :key="'d' + li" class="content-divider"></div>
            <div v-if="!line.isNumLine" :key="'l' + li" class="content-line" :class="{ 'line--alt': li % 2 === 1 }">
              <div class="content-line__text" v-html="line.html"></div>
              <button v-if="item.resultText==='开？00'" type="button" class="content-line__copy" :class="{ 'content-line__copy--copied': copiedLine === idx + '-' + li }" @click="copyText(line.text, idx + '-' + li)">{{ copiedLine === idx + '-' + li ? '已复制' : '复制' }}</button>
            </div>
            <div v-else :key="'n' + li" class="num-line" :class="{ 'line--alt': li % 2 === 1 }">
              <div class="num-line__label-row">
                <span class="num-line__label" v-html="line.labelHtml"></span>
                <button v-if="item.resultText==='开？00'" type="button" class="content-line__copy" :class="{ 'content-line__copy--copied': copiedLine === idx + '-' + li }" @click="copyText(line.text, idx + '-' + li)">{{ copiedLine === idx + '-' + li ? '已复制' : '复制' }}</button>
              </div>
              <div class="num-line__grid">
                <span v-for="(n, ni) in line.nums" :key="ni" class="num-cell" v-html="n.html"></span>
              </div>
            </div>
          </template>
        </div>
        <div v-if="hitBarText(item)" class="first-prediction__hit-bar">
          {{ hitBarPrefix(item) }}<span class="first-prediction__hit-bar__hl">{{ hitBarInner(item) }}</span>中奖很简单
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const ZODIACS = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪']

export default {
  name: 'FirstPredictionCard',
  props: {
    sections: { type: Array, default: () => [] },
    gameLabel: { type: String, default: '' }
  },
  data() {
    return {
      copiedLine: null,
      copyTimerId: null
    }
  },
  beforeDestroy() {
    if (this.copyTimerId != null) {
      clearTimeout(this.copyTimerId)
      this.copyTimerId = null
    }
  },
  computed: {
    section() {
      return this.sections[0] || null
    },
    visibleItems() {
      if (!this.section) return []
      return this.section.items.filter(it => this.hasHit(it))
    }
  },
  methods: {
    periodShort(period) {
      const s = String(period ?? '')
      return s.length > 4 ? s.slice(4) : s
    },
    escapeHtml(s) {
      return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    },
    matchKeys(matchKey) {
      return String(matchKey || '')
        .split(/[,，]/)
        .map(k => this.escapeHtml(k.trim()))
        .filter(Boolean)
        .sort((a, b) => b.length - a.length)
    },
    rawMatchKeys(matchKey) {
      const s = String(matchKey || '')
      if (s.includes('？')) return []
      return s.split(/[,，]/).map(k => k.trim()).filter(Boolean)
    },
    hasHit(item) {
      if (item.resultText === '开？00') return true
      const rawKeys = this.rawMatchKeys(item.matchKey)
      if (rawKeys.length === 0) return false
      return String(item.contentText || '')
        .split(/\r?\n/)
        .some(line => {
          const t = line.trim()
          return t && rawKeys.some(k => t.includes(k))
        })
    },
    itemZodiac(item) {
      const mk = String(item.matchKey || '')
      for (const z of ZODIACS) {
        if (mk.includes(z)) return z
      }
      const rt = String(item.resultText || '')
      for (const z of ZODIACS) {
        if (rt.includes(z)) return z
      }
      return null
    },
    smallestHitGroup(item) {
      const z = this.itemZodiac(item)
      if (!z) return null
      let min = null
      String(item.contentText || '').split(/\r?\n/).forEach(line => {
        const m = line.trim().match(/^(\d+)\s*肖\s*[：:]\s*(.+)$/)
        if (!m) return
        const n = parseInt(m[1], 10)
        if (m[2].includes(z) && (min == null || n < min)) min = n
      })
      return min
    },
    hitBarPrefix(item) {
      return `${this.periodShort(item.period)}期：${this.section.sectionName}`
    },
    hitBarInner(item) {
      const mk = String(item.matchKey || '')
      const zodiac = ZODIACS.find(z => mk.includes(z)) || null
      const num = mk.match(/\d+/)
      if (zodiac && num) return `<${zodiac}-${num[0]}>`
      if (!zodiac && num) return `<${num[0]}>`
      if (zodiac) {
        const n = this.smallestHitGroup(item)
        if (n == null) return ''
        return `<${n}肖中>`
      }
      return ''
    },
    hitBarText(item) {
      if (item.resultText === '开？00') return ''
      if (!String(item.resultText || '').includes('准')) return ''
      return this.hitBarInner(item)
    },
    highlightText(text, keys) {
      const escaped = this.escapeHtml(text)
      if (keys.length === 0) return escaped
      const pattern = keys.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')
      return escaped.replace(new RegExp(`(${pattern})`, 'g'), '<span class="hl">$1</span>')
    },
    parsedLines(item) {
      console.log("item", item)
      const keys = this.matchKeys(item.matchKey)
      const rawKeys = this.rawMatchKeys(item.matchKey)
      const isPending = item.resultText === '开？00'
      const lines = String(item.contentText || '').split(/\r?\n/)
      const out = []
      let lastNonEmpty = ''
      lines.forEach(line => {
        const t = line.trim()
        if (!t) return
        if (!isPending && (rawKeys.length === 0 || !rawKeys.some(k => t.includes(k)))) return
        const entry = {
          text: t,
          divider: t.includes('码') && lastNonEmpty.includes('肖'),
          isNumLine: false
        }
        const m = t.match(/^(.+?码)\s*[:：]\s*(.+)$/)
        if (m) {
          entry.isNumLine = true
          entry.labelHtml = this.highlightText(m[1] + '：', keys)
          entry.nums = m[2]
            .split(/[,，、\s]+/)
            .filter(Boolean)
            .map(n => ({ html: this.highlightText(n, keys) }))
        } else {
          entry.html = this.highlightText(t, keys)
        }
        out.push(entry)
        lastNonEmpty = t
      })
      return out
    },
    copyText(text, key) {
      const done = () => {
        this.copiedLine = key
        if (this.copyTimerId != null) clearTimeout(this.copyTimerId)
        this.copyTimerId = setTimeout(() => {
          this.copiedLine = null
          this.copyTimerId = null
        }, 3000)
      }
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done).catch(() => this.fallbackCopy(text, done))
      } else {
        this.fallbackCopy(text, done)
      }
    },
    fallbackCopy(text, done) {
      const ta = document.createElement('textarea')
      ta.value = text
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      document.body.appendChild(ta)
      ta.select()
      try {
        document.execCommand('copy')
        done()
      } catch (e) {
        // silent
      }
      document.body.removeChild(ta)
    }
  }
}
</script>

<style scoped>
.first-prediction {
  margin: clamp(0.5rem, 2.5vw, 0.625rem) 0;
}
.first-prediction__card {
  background: #fff;
  border: 1px solid #000000;
  //border-radius: clamp(0.5rem, 2.5vw, 0.75rem);
  margin-bottom: clamp(0.375rem, 2vw, 0.5rem);
  box-shadow: 0 2px 8px rgba(30, 107, 214, 0.08);
  overflow: hidden;
}
.first-prediction__header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: clamp(0.5rem, 2.5vw, 0.625rem);
  background: linear-gradient(180deg, #e8f3fc 0%, #f3a404 100%);
}
.first-prediction__name {
  font-weight: 700;
  font-size: clamp(1.2rem, 3vw, 1rem);
  color: #0d2d52;
}
.first-prediction__period {
  display: block;
  text-align: center;
  font-size: clamp(0.9rem, 2.6vw, 0.8125rem);
  color: #df0e0e;
  //font-weight: 800;
  padding: 0.5rem 0 0 0;
  //color: #df0e0e;
  font-weight: 600;
  //font-size: 0.85rem;
}
.first-prediction__content {
  padding: clamp(0.3rem, 2.5vw, 0.75rem);
  font-size: clamp(1rem, 2.8vw, 0.875rem);
  line-height: 1.4;
  white-space: pre-line;
  word-break: break-all;
  color: #1a1a1a;
  font-weight: 700;
  text-align: center;
}
.first-prediction__content ::v-deep .hl {
  color: #d32f2f;
  font-weight: 800;
  background: #ffeb3b;
  padding: 0 2px;
  border-radius: 2px;
}
.content-divider {
  border-top: 2px dashed #d58352;
  margin: 0.4rem 0;
}
.first-prediction__row--divider {
  border-top: 2px solid #ec8873;
}
.first-prediction__hit-bar {
  background: #FFCCFF;
  color: #0000ff;
  font-weight: 700;
  text-align: center;
  padding: 0.35rem 0.5rem;
  font-size: 0.95rem;
  margin: 0 0.5rem 0.5rem;
  border-radius: 4px;
}
.first-prediction__hit-bar__hl {
  color: #ff0000;
  font-size: 1.25rem;
  font-weight: 800;
}
.content-line {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
.content-line,
.num-line {
  border-radius: 6px;
  padding: 0.15rem 0.4rem;
  margin-bottom: 0.25rem;
  background: #f2f8ff;
}
.line--alt {
  background: #fff7ef;
}
.content-line__text {
  flex: 1;
}
.content-line__copy {
  flex: 0 0 auto;
  border: 1px solid #d58352;
  background: #fff;
  color: #d58352;
  border-radius: 4px;
  font-size: 0.75rem;
  line-height: 1.5;
  padding: 0 0.5rem;
  cursor: pointer;
}
.content-line__copy--copied {
  border-color: #2e7d32;
  color: #2e7d32;
  background: #e8f5e9;
}
.num-line__label-row {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-bottom: 0.1rem;
}
.num-line__label {
  flex: 1;
}
.num-line__grid {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  row-gap: 0.1rem;
}



.card_header{
  border: 8px double #ff9900;
  background: #009900;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff3e0;
}
</style>
